import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';


@Injectable()
export class ConfigComponent {
    /**
     * Variable url para utilizar en el envio de peticiones al webserive
     */


    //  urlOmt  = 'http://backend.myjtrabajoenalturas.com/public/';
    //  urlOmt  = 'backend.myjtrabajoenalturas.com/public/estudiantes/';
    //  urlOmt  = 'http://webservice.myjtrabajoenalturas.com/myjwebservice/web/app_dev.php/';
    //  urlOmt  = 'http://127.0.0.1/ances/MyjProyecto/myjwebservice/web/app_dev.php/';
    // urlOmt  = 'http://myjwebservice.myjtrabajoenalturas.net/web/app_dev.php/';
    urlOmt  = 'https://ws.myjtrabajoenalturas.net/public/api/';


    /**
     * contiene la llave(apikey) para hacer uso de los servicios de google maps
     *
     * @NOTE: TENER EN CUENTA QUE ESTA API KEY TAMBIEN ESTÀ EN EL ARCHIVO APP.MODULE.TS
     * @type {string}
     */
    public apiKeyGMap: String = 'AIzaSyCz-uv5HrrAaOX7cn4nC0EA_WCRi6WrgmM';


    /**
     * Metod encargado de devolver la Ip de los webservice
     * Nota: Sin sd en la URL
     */
    getUrlOmt() {
        return this.urlOmt;
    }
}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/config/config.ts